module.exports = __webpack_public_path__ + "static/media/bi.12a40d8d.svg";